import Keycloak from 'keycloak-js'

const hostname = window.location.hostname

const defaultConfig = {
    url: 'https://accas-dev.anycubic.com:30048/',
    realm: 'anycubic',
}

const domainConfigMap = {
    'bc.anycubic.com': {
        url: 'https://accas.anycubic.com/',
        realm: 'anycubic',
    },
    'bc-dev.anycubic.com': {
        url: 'https://accas-dev.anycubic.com:30048/',
        realm: 'anycubic',
    },
    'bc-gray.anycubic.com': {
        url: 'https://accas-dev.anycubic.com:30048/',
        realm: 'anycubic-gray',
    },
}

const envConfig = domainConfigMap[hostname] || defaultConfig

const keycloak = new Keycloak({
    url: envConfig.url,
    realm: envConfig.realm,
    clientId: 'acerp',
})

export default keycloak
